import { Part, ModuleSpec } from './types';

export function inferRole(p: { w: number; d: number; h: number, partName?: string }, M: { W: number; D: number; H: number }): Part['role'] {
  const eq = (a: number, b: number, tol = 5) => Math.abs(a - b) <= tol;
  const isThin = (v: number) => v <= 30;            // 판재 두께
  const isThinBack = (v: number) => v <= 12;        // 뒷판은 9T 등

  if (p.partName) {
    if (p.partName.includes('바닥')) return 'bottom';
    if (p.partName.includes('천장') || p.partName.includes('상판')) return 'top';
    if (p.partName.includes('측판') || p.partName.includes('측면')) return 'sideL';
    if (p.partName.includes('선반')) return 'shelf';
    if (p.partName.includes('뒷판')) return 'back';
    if (p.partName.includes('도어') || p.partName.includes('문')) return 'door';
    if (p.partName.includes('LED') || p.partName.includes('조명')) return 'led';
  }

  // 바닥/천장: 폭 ≈ W, 깊이 ≈ D, 두께 얇음
  if (eq(p.w, M.W) && eq(p.d, M.D) && isThin(p.h)) return 'bottom';
  // 측판: 깊이 ≈ D, 높이 ≈ H − 2t (또는 ≈ H), 폭 얇음
  if (eq(p.d, M.D) && (eq(p.h, M.H) || eq(p.h, M.H - 36)) && isThin(p.w)) return 'sideL';
  // 선반: 폭 ≈ W − 2t, 두께 얇음, 높이가 작음
  if (eq(p.w, M.W - 36, 8) && isThin(p.h)) return 'shelf';
  // 뒷판: 9T, 폭과 높이가 모듈에 가까움
  if (isThinBack(p.h) || isThinBack(p.d)) return 'back';
  
  return 'shelf'; // safe default
}
